<template>
  <sweet-modal title="Cash Receipts (Journal Transaction)" width="700" blocking ref="modal">
    <div class="content">
      <el-card class="box-card">
        <span class="comming-soon">Coming Soon</span>
        <p>There are open transactions for this client.</p>
        <p>Apply this payment to open transactions?</p>
        <div style="display: flex; align-items: center; gap: 20px; margin: 0 auto; justify-content: center">
          <el-button type="primary" disabled size="mini">Yes</el-button>
          <el-button type="primary" disabled size="mini">No</el-button>
        </div>
      </el-card>
      <div style="display: flex; align-items: center; margin: 0 auto; justify-content: center; flex-direction: column; margin-bottom: 20px;">
        <p>This cash was received for:</p>
        <el-button type="primary" size="mini" style="width: 240px;" @click="setReceiveFor('sales')">Sales</el-button>
        <p>or</p>
        <el-button type="primary" size="mini" style="width: 240px;" @click="setReceiveFor('sales')">Deposits (Downpayments)</el-button>
        <!-- <el-button type="primary" size="mini" style="width: 240px;" @click="setReceiveFor('deposits')">Deposits (Downpayments)</el-button> -->
        <p>or</p>
        <el-button type="primary" size="mini" style="width: 240px;" @click="setReceiveFor('sales')">Others</el-button>
        <!-- <el-button type="primary" size="mini" style="width: 240px;" @click="setReceiveFor('others')">Others</el-button> -->
        <p>(E.g Other could be Insurance Recoveries)</p>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'

export default {
  name: "CashReceiptJournalModal",
  components: {
    SweetModal,
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout
    },
  },
  methods: {
    openModal() {
      this.$refs.modal.open();
    },
    setReceiveFor(value) {
      this.$emit('setReceiveFor', value)
      this.$refs.modal.close()
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  width: 100%;
  padding: 10px;
  margin: 0 auto;
  .box-card {
    min-width: 340px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    position: relative;
    .comming-soon {
      font-size: 12px;
      position: absolute;
      top: 10px;
      left: 10px;
      color: #ff9696;
    }
  }
}
</style>